/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InformationGatheringRepresentativeRelationship {
  ParentOrGuardian = 'parent-or-guardian',
  FamilyMember = 'family-member',
  FriendOrNeighbour = 'friend-or-neighbour',
  HealthcareProfessionalOrCarer = 'healthcare-professional-or-carer',
  Other = 'other'
}
